"use client";

import React, { FC, useEffect, useState } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Icon from "@/components/ui/Icon/Icon";
import useMediaQuery from "@/hooks/useMediaQuery";

import "./StartChat.css";

interface Props {}
declare global {
  interface Window {
    Genesys: any; // Declaring Genesys on the window object
  }
}
type journeyType = "sales" | "csr" | "";
export type InquiryDataType = { inquiryName: string; inquiryID: string; campaignName?: string; customerName?: string; tSAEmail?: string };

const StartChat: FC<Props> = () => {
  const [isMessengerOpen, setIsMessengerOpen] = useState(false);
  const [genesysReady, setGenesysReady] = useState(false);
  const isMobile = useMediaQuery("(max-width: 600px)");

  useEffect(() => {
    const handleMessengerClosed = (e: any) => {
      setIsMessengerOpen(false);
    };

    const handleMessengerReady = () => setGenesysReady(true);
    if (window?.Genesys) {
      window?.Genesys("subscribe", "Messenger.ready", handleMessengerReady);
      window?.Genesys("subscribe", "Messenger.closed", handleMessengerClosed);
    }

    return () => {
      if (window?.Genesys) {
        window?.Genesys("unsubscribe", "Messenger.ready", handleMessengerReady);
        window?.Genesys("unsubscribe", "Messenger.closed", handleMessengerClosed);
      }
    };
  }, []);

  const handleClickDiaglogue = () => {
    if (isMessengerOpen) {
      window.Genesys("command", "Messenger.close");
      setIsMessengerOpen(false);
      return;
    }
    if (window.Genesys) {
      window.Genesys("command", "Messenger.open");
      setIsMessengerOpen(true);
      return;
    }
  };
  return (
    <>
      {isMessengerOpen && isMobile ? (
        <></>
      ) : (
        <div className="start-chat-holder shadow-2xl" style={{ marginBottom: isMobile ? "" : "35px" }}>
          {genesysReady && (
            <Button
              rounded={true}
              size={ButtonSize.MEDIUM}
              variant={ButtonVariant.PRIMARY}
              theme={ButtonTheme.GOLD}
              onClick={handleClickDiaglogue}
              onTouchStart={handleClickDiaglogue}
            >
              {isMessengerOpen ? (
                <Icon name="cross" size="24" title="cross" className="stroke-black" />
              ) : (
                <Icon name="chat" size="24" title="cross" className="stroke-black" />
              )}
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default StartChat;
